import { Component } from 'vue';
import { RouteMeta, RouteRecordRaw } from 'vue-router';

import { TSVueIcons } from 'tsv2-library/dist/src/components/v2/Icon/Icon.vue';
import { MenuOption } from 'tsv2-library/dist/src/components/v2/Menu/Menu.vue';

export type ExtendedMenuOption = MenuOption & {
  for?: string[];
  command?: () => void | Promise<void>;
};

/**
 *
 * @param label {string} Label of the option.
 * @param icon {TSVueIcons} Icon of the option.
 * @param command {() => void | Promise<void>} The command to execute when the option is clicked.
 * @param f {string[]} An identifier the option to be used for.
 * @param danger {boolean} Whether the option is using the danger style.
 * @param visible {boolean} Whether the option is visible.
 * @returns {ExtendedMenuOption}
 */
export const menuOptionBuilder = (
  label: string,
  icon: TSVueIcons,
  command: () => void | Promise<void>,
  f?: string[],
  danger?: boolean,
  visible?: boolean,
): ExtendedMenuOption => {
  return {
    for: f,
    label,
    icon,
    danger,
    command,
    visible,
  };
};

export const routeBuilder = (
  path: string,
  name: string,
  component: Component,
  redirect?: {
    name: string;
  },
  meta?: RouteMeta,
  children?: RouteRecordRaw[],
): RouteRecordRaw => {
  if (redirect && children) {
    return {
      path,
      name,
      component,
      redirect,
      children,
      meta,
    };
  }
  return {
    path,
    name,
    component,
    meta,
  };
};
